"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Friction;
var K = 3;
function Friction(x, v, secPerStep, elapsed) {
  var dv = -K * v * secPerStep;
  var nextV = v > 0 ? Math.max(v + dv, 0) : Math.min(v + dv, 0);
  return [x + nextV * secPerStep, nextV, Math.abs(dv) < 0.00001];
}


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/steppers/Friction.js
// module id = 76
// module chunks = 0